export const EmailTemplateFooter = () => (
    <div>       
        <table width="100%" cellPadding="0" cellSpacing="10" style={{ backgroundColor: '#FFFFFF', color: '#000000' }}>
            <tr>
                <td style={{ padding: '30px 20px', textAlign: 'center' }}>
                    {/* Buttons */}
                    <div style={{ margin: '10px' }}>
                        <a
                            href="https://opencallforartists.com/explore"
                            style={{
                                display: 'inline-block',
                                padding: '10px 20px',
                                backgroundColor: '#16404D',
                                color: '#FFFFFF',
                                textDecoration: 'none',
                                borderRadius: '5px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                margin: '5px 20px',
                            }}
                        >
                            Explore All
                        </a>
                        <a
                            href="https://opencallforartists.com/pricing"
                            style={{
                                display: 'inline-block',
                                padding: '10px 20px',
                                backgroundColor: '#16404D',
                                color: '#FFFFFF',
                                textDecoration: 'none',
                                borderRadius: '5px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                margin: '5px 20px',
                            }}
                        >
                            Post Open Call
                        </a>
                        <a
                            href="https://opencallforartists.com/sign-up"
                            style={{
                                display: 'inline-block',
                                padding: '10px 20px',
                                backgroundColor: '#16404D',
                                color: '#FFFFFF',
                                textDecoration: 'none',
                                borderRadius: '5px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                margin: '0 20px',
                            }}
                        >
                            Join Us
                        </a>
                    </div>

                    {/* Footer Text */}
                    <p style={{ fontSize: '16px', color: '#4A5568' }}>
                        Don't miss out on this amazing opportunity! Apply now and let your creativity shine! For questions, contact us at{' '}
                        <a href="mailto:info@opencallforartists.com" style={{ color: '#2D3748', textDecoration: 'underline' }}>
                            info@opencallforartists.com
                        </a>.
                    </p>
                    <p style={{ fontSize: '14px', color: '#4A5568' }}>
                        <strong>Warm regards,</strong><br />
                        Open Call For Artists
                    </p>

                    {/* Social Icons */}
                    <div style={{ display: "flex", justifyContent: "center", marginTop: '30px' }}>
                        <a href="https://www.facebook.com/ArtsToHeartsProject">
                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTtfbcYeYgf0wQJ-LSPm3CPbyB7T1p0f5bnaA&s" alt="Facebook" style={{ width: '24px', height: '24px', margin: '0 10px' }} />
                        </a>
                        <a href="https://www.instagram.com/opencallforartists_/">                            
                            <img src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"  alt="Instagram" style={{ width: "24px", height: "24px", margin: "0 10px" }} />
                        </a>
                        <a href="https://www.youtube.com/@artstoheartspodcast">
                            <img src="https://t3.ftcdn.net/jpg/04/74/05/94/360_F_474059464_qldYuzxaUWEwNTtYBJ44VN89ARuFZ2pS.jpg" alt="YouTube" style={{ width: '24px', height: '24px', margin: '0 10px' }} />
                        </a>
                    </div>

                    {/* Website & Contact Us */}
                    <p style={{ fontSize: '14px', color: '#A0AEC0', marginTop: '30px' }}>
                        <p style={{ color: '#2D3748', textDecoration: 'none' }}>You are receiving this email because you subscribed to our updates. If you'd like to opt out, please click{' '}
                            <a href="https://opencallforartists.com/unsubscribe/" style={{ color: '#0000FF', textDecoration: 'none' }}>
                                unsubscribe.
                            </a>
                        </p>
                        <br />
                        <a href="https://opencallforartists.com" style={{ color: '#2D3748', textDecoration: 'none' }}>
                            Visit our website for more updates.
                        </a>
                        <br />
                        <a href="mailto:info@opencallforartists.com" style={{ color: '#A0AEC0', textDecoration: 'none' }}>
                            Contact Us
                        </a>
                    </p>
                </td>
            </tr>
        </table>
    </div>
);